import Browser from '@mindful-web/marko-web/browser';
import Global from '@industrial-media/package-global/browser';

Global(Browser);

export default Browser;
